/*eslint-disable*/
import React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";

export default function Footer() {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems="center"
      justifyContent="center"
      py="10px"
      bg={"yellow.300"}
    >
      <Text
        color="blue.800"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as="span">Made with ❤️❤️❤️ by </Text>
        <Link color="blue.800" href="#" target="_blank" fontWeight="bold">
          Lune Team
        </Link>
      </Text>
    </Flex>
  );
}
